import { render } from "./roomManage.vue?vue&type=template&id=5c27ee4a&scoped=true&ts=true"
import script from "./roomManage.vue?vue&type=script&lang=ts"
export * from "./roomManage.vue?vue&type=script&lang=ts"

import "./roomManage.vue?vue&type=style&index=0&id=5c27ee4a&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c27ee4a"]])

export default __exports__